import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { merge } from 'lodash';
import xlsx from 'xlsx';
import batch from 'batch-promises';
import qs from 'qs';
import EnhancedTable from './EnhancedTable';
import { decorateData } from '../common/OrderUtil';
import Loading from '../loading';
import { columnDataForExport, valueFormat, dateTimeFormat } from '../common/constants';
import { getOrders, orderUpdate, removeTrackingNumber, splitShipment, getCarriers } from '../../api';
import { transferToCSV } from '../common/OrderUtil';
import DeleteDialog from './DeleteDialog';

class Orders extends React.Component {
  constructor(props) {
    super(props);
    const query = qs.parse(window.location.hash.replace('#/orders/?', ''));
    const shippingTime = query.shippingTime;
    this.state = {
      isFetching: true,
      orderToRemoveTracking: null,
      carriers: [],
      result: {
        data: [],
        metadata: {},
      },
      filters: shippingTime
        ? { shippingTime }
        : {
            shippingTime: 'late,today,coming',
            createdFrom: moment()
              .subtract(180, 'day')
              .format(dateTimeFormat),
            createdTo: moment().format(dateTimeFormat),
          },
      pageInfo: props.pageInfo
        ? props.pageInfo
        : {
            pageSize: 20, // Defaults to 10 if not specified
            page: 0,
            order: 'asc',
            orderBy: 'created_at',
          },
    };
    this.handleOpenDelete = this.handleOpenDelete.bind(this);
    this.handleCloseDelete = this.handleCloseDelete.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.result) {
      this.setState({ result: nextProps.result, pageInfo: nextProps.pageInfo });
    }
  }

  componentWillMount() {
    //Add carriers
    getCarriers().then(carriers =>{
      this.setState({carriers: [{name:''},...carriers.map(carrier=>{return {name:carrier.name}})]});
    })
    if (!this.props.result) {
      this.loadData();
    }
  }

  loadData = () => {
    const pageInfo = this.state.pageInfo;
    getOrders(merge(this.state.filters, pageInfo)).then(result => {
      if (result && result.errors && result.errors.length > 0) {
        this.setState({ errors: result.errors, isFetching: false });
      } else {
        result.data = decorateData(result.data);
        this.setState({ result, isFetching: false });
      }
    });
  };

  handleFilter = filtersObj => {
    const filters = this.state.filters;
    const pageInfo = this.state.pageInfo;
    pageInfo.page = 0;
    let hastrackingNumberFilter = false;
    if (filtersObj) {
      Object.keys(filtersObj).forEach(key => {
        filters[key] = filtersObj[key];
        if (key === 'hasTrackingNumber' && !filters[key]) {
          hastrackingNumberFilter = true;
        }
        // filter blank filter
        if (filters[key] === '') {
          delete filters[key];
        }
      });
    }
    if (hastrackingNumberFilter) {
      delete filters.hasTrackingNumber;
    }

    this.setState({ filters, pageInfo });
    this.doFilter();
  };

  doRest = () => {
    this.setState({ filters: {} });
  };

  handleOpenDelete(orderId, shipmentRef) {
    this.setState({
      orderToRemoveTracking: {
        orderId,
        shipmentRef,
      },
    });
  }

  handleCloseDelete() {
    this.setState({
      orderToRemoveTracking: null,
    });
  }

  doExport = () => {
    const fileName = `Order - (${moment(new Date()).format('YYYY-MM-DD')}).csv`;
    // this.setState({ isFetching: true});
    const pageInfo = {
      pageSize: 1000,
      page: 0,
      order: 'asc',
      orderBy: 'created_at',
    };
    this.setState({ isFetching: true });
    getOrders(merge(this.state.filters, pageInfo)).then(result => {
      // return;
      if (result && result.errors && result.errors.length > 0) {
        this.setState({ errors: result.errors });
      } else {
        const dataForExport = decorateData(result.data);
        const data = dataForExport.map(order =>
          columnDataForExport.map(item => {
            if (order[item.id] && typeof order[item.id] === 'object') {
              if (item.id === 'productShowNameWithoutBarCode') {
                return order[item.id].join('.\n');
              }
              return order[item.id].join('\n');
              // return order[item.id].join(String.fromCharCode(10));
            }
            return valueFormat(item, order[item.id]);
          })
        );
        data.unshift(columnDataForExport.map(item => item.label));
        const csvFile = transferToCSV(data);
        const blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) {
          // IE 10+
          navigator.msSaveBlob(blob, fileName);
        } else {
          const link = document.createElement('a');
          if (link.download !== undefined) {
            // feature detection
            // Browsers that support HTML5 download attribute
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', fileName);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      }
      this.setState({ isFetching: false });
    });
    return '';
  };

  doImport = e => {
    let errors = [];
    this.setState({ isFetching: true });
    if (e.target.files.length > 1) {
      this.setState({
        isFetching: false,
        errors: [{ message: 'Sorry, you can only upload one file at a time.' }],
      });
      return;
    }
    const reader = new FileReader();
    reader.onload = ({ target: { result } }) => {
      const orderShipmentRefIndex = 1;
      const fieldsNumber = columnDataForExport.length;
      const shippingCostIndex = fieldsNumber - 4;
      const carrierfIndex = fieldsNumber - 3;
      const trackingNumberIndex = fieldsNumber - 2;
      const inputShippingCostIndex = fieldsNumber - 1;
      let ws = null;
      try {
        ws = xlsx.read(result, { type: 'binary' }).Sheets.Sheet1;
      } catch (e) {
        this.setState({
          isFetching: false,
          errors: [{ message: 'Can not read the file, please double check is it a correct one.' }],
        });
        return;
      }
      const orderShipmentRef = xlsx.utils.sheet_to_json(ws, { header: 1 })[0][
        orderShipmentRefIndex
      ];
      const carrier = xlsx.utils.sheet_to_json(ws, { header: 1 })[0][carrierfIndex];
      const trackingNumber = xlsx.utils.sheet_to_json(ws, { header: 1 })[0][trackingNumberIndex];
      const shippingCost = xlsx.utils.sheet_to_json(ws, { header: 1 })[0][inputShippingCostIndex];

      if (
        orderShipmentRef != 'Shipping REF' ||
        trackingNumber != 'Tracking Number' ||
        carrier != 'Carrier' ||
        shippingCost != 'True Shipping Cost (GST excluded)'
      ) {
        this.setState({
          isFetching: false,
          errors: [
            {
              message: `Can not find 'Shipping REF' 
              or 'Carrier' 
              or 'Tracking Number' 
              or 'True Shipping Cost (GST excluded)', 
              please double check is the file a correct one.`,
            },
          ],
        });
        return;
      }
      const orders = [];
      const courierList = this.state.carriers.map(item => item.name);
      xlsx.utils.sheet_to_json(ws, { header: 1 }).forEach((row, i) => {
        if (i === 0) return;
        const currentError = [];
        const carrier = row[carrierfIndex] ? row[carrierfIndex].trim() : '';
        if (!row[orderShipmentRefIndex]) {
          currentError.push({
            message: `Line ${i} error: 'Shipping REF' can not be empty.`,
          });
        }
        if (!carrier) {
          currentError.push({
            message: `Line ${i} error: 'Carrier' can not be empty.`,
          });
        }
        if (
          row[inputShippingCostIndex] &&
          (isNaN(row[inputShippingCostIndex]) && row[inputShippingCostIndex] !== '')
        ) {
          currentError.push({
            message: `Line ${i} error: 'True Shipping Cost' should be a number or empty.`,
          });
        }
        if (row[inputShippingCostIndex] && row[inputShippingCostIndex].toString().length > 8) {
          currentError.push({
            message: `Line ${i} error: True Shipping Cost's length can not be more than 8.`,
          });
        }

        if (!courierList.includes(carrier)) {
          currentError.push({ message: `Line ${i} error: 'carrier' is not in courier list.` });
        }
        if (row[inputShippingCostIndex] && row[inputShippingCostIndex] > row[shippingCostIndex]) {
          currentError.push({
            message: `Line ${i} error: True Shipping Cost can not more than the Quoted Shipping Cost .`,
          });
        }
        if (currentError.length > 0) {
          errors = [...errors, ...currentError];
        } else {
          orders.push({
            orderShipmentRef: row[orderShipmentRefIndex],
            carrier: carrier,
            trackingNumber: row[trackingNumberIndex],
            shippingCost: row[inputShippingCostIndex],
          });
        }
      });
      batch(2, orders, order =>
        orderUpdate({
          orderShipmentRef: order.orderShipmentRef,
          trackingNumber: order.trackingNumber,
          carrier: order.carrier,
          supplierInputCost: order.shippingCost,
        })
      ).then(res => {
        res.forEach(result => {
          if (result.errors) {
            errors = [...errors, ...result.errors];
          }
        });
        if (errors.length > 0) {
          this.setState({ errors, isFetching: false });
        }
        this.loadData();
      });
    };
    return reader.readAsBinaryString(e.target.files[0]);
  };

  doFilter = () => {
    const filters = this.state.filters;
    if (filters.createdFrom && filters.createdTo && filters.createdTo < filters.createdFrom) {
      this.setState({
        errors: [
          {
            message: "Created Date: The 'to' date can not be smaller than the 'from' date.",
          },
        ],
      });
    } else {
      if (!filters.createdFrom) {
        delete filters.createdFrom;
        delete filters.createdTo;
      }
      this.setState({ isFetching: true });
      this.loadData();
    }
  };

  handleCloseAlert = type => {
    this.setState({ errors: null });
  };

  setTrackingNumber = (order, trackingNumber) => {
    // Change nothing, then do nothing
    if (order.trackingNumber == trackingNumber) {
      return;
    }
    if (!order.courier) {
      this.setState({
        errors: [{ message: 'Please chose a courier first.' }],
      });
      return;
    }

    this.setState({ isFetching: true });
    if (trackingNumber) {
      orderUpdate({
        orderShipmentRef: order.shipmentRef,
        trackingNumber,
        carrier: order.courier,
      }).then(res => {
        if (res && res.errors) {
          return this.setState({
            errors: res.errors,
            isFetching: false,
          });
        }
        this.setState({ isFetching: true });
        this.loadData();
      });
    } else {
      this.setState({
        isFetching: false,
        errors: [{ message: 'Tracking number can not be set to empty.' }],
      });
    }
  };

  setCourier = (order, carrier) => {
    this.setState({ isFetching: true });
    if (carrier) {
      orderUpdate({
        orderShipmentRef: order.shipmentRef,
        carrier,
      }).then(res => {
        if (res && res.errors) {
          return this.setState({
            errors: res.errors,
            isFetching: false,
          });
        }
        this.setState({ isFetching: true });
        this.loadData();
      });
    } else {
      this.setState({
        errors: [{ message: 'Carrier can not be set to empty.' }],
      });
    }
  };

  setShipmentCost = (order, supplierInputCost) => {
    // Change nothing, then do nothing
    if (order.supplierInputCost == supplierInputCost) {
      return;
    }
    if (supplierInputCost && supplierInputCost > order.shippingCost) {
      return this.setState({
        errors: [{ message: 'True Shipping Cost can not more than the shipping cost.' }],
      });
    }
    this.setState({ isFetching: true });
    orderUpdate({
      orderShipmentRef: order.shipmentRef,
      supplierInputCost,
    }).then(res => {
      if (res && res.errors) {
        return this.setState({
          errors: res.errors,
          isFetching: false,
        });
      }
      this.setState({ isFetching: true });
      this.loadData();
    });
  };

  removeTracking = (orderId, shipmentRef) => {
    this.setState({ isFetching: true });
    removeTrackingNumber(orderId, shipmentRef).then(res => {
      if (res && res.errors) {
        this.setState({
          errors: res.errors,
          isFetching: false,
          orderToRemoveTracking: null,
        });
      } else {
        this.setState({
          isFetching: true,
          orderToRemoveTracking: null,
        });
        this.loadData();
      }
    });
  };

  handleChangePage = page => {
    if (this.props.handleChangePage) {
      this.props.handleChangePage(page);
    } else {
      const pageInfo = this.state.pageInfo;
      pageInfo.page = page;
      this.setState({ pageInfo, isFetching: true });
      this.loadData();
    }
  };

  handleChangePageSize = value => {
    if (this.props.handleChangePageSize) {
      this.props.handleChangePageSize(value);
    } else {
      const pageInfo = this.state.pageInfo;
      pageInfo.pageSize = value;
      pageInfo.page = 0;
      this.setState({ pageInfo, isFetching: true });
      this.loadData();
    }
  };

  handleRequestSort = (order, orderBy) => {
    const pageInfo = this.state.pageInfo;
    pageInfo.order = order;
    pageInfo.orderBy = orderBy;
    pageInfo.page = 0;
    this.setState({ isFetching: true });

    this.loadData();
  };

  handleOnSubmitSplit = async (order, orderLineIds) => {
    this.setState({ isFetching: true });
    await splitShipment({ orderId: order.orderid, orderLineIds }).then(res => {
      if (res && res.status === 'OK') {
        this.loadData();
      } else if (res && res.errors) {
        this.setState({
          errors: res.errors,
          isFetching: false,
        });
      }
    });
  };

  render() {
    const { result, errors, filters, pageInfo, isFetching } = this.state;
    const { readOnly, withOutToolBar, withOutPagination, columnData } = this.props;
    return (
      <div style={{ width: '100%' }}>
        <div>
          <EnhancedTable
            result={result}
            handleFilter={this.handleFilter}
            doFilter={this.doFilter}
            handleCloseAlert={this.handleCloseAlert}
            handleOnSubmitSplit={this.handleOnSubmitSplit}
            doRest={this.doRest}
            doExport={this.doExport}
            doImport={this.doImport}
            removeTracking={this.removeTracking}
            errors={errors}
            filters={filters}
            setTrackingNumber={this.setTrackingNumber}
            setCourier={this.setCourier}
            setShipmentCost={this.setShipmentCost}
            pageInfo={pageInfo}
            handleChangePage={this.handleChangePage}
            handleChangePageSize={this.handleChangePageSize}
            handleRequestSort={this.handleRequestSort}
            withOutToolBar={withOutToolBar}
            readOnly={readOnly}
            withOutPagination={withOutPagination}
            columnData={columnData}
            handleCloseDelete={this.handleCloseDelete}
            handleOpenDelete={this.handleOpenDelete}
            open={this.state.openDelete}
            carriers={this.state.carriers}
          />
        </div>
        <div>{!withOutToolBar && <Loading show={isFetching} text="Loading..." />}</div>
        {this.state.orderToRemoveTracking && (
          <DeleteDialog
            currentOrder={this.state.orderToRemoveTracking}
            handleClose={this.handleCloseDelete}
            handleSubmit={this.removeTracking}
          />
        )}
      </div>
    );
  }
}

Orders.propTypes = {
  withOutToolBar: PropTypes.boolean,
  readOnly: PropTypes.boolean,
  columnData: PropTypes.object,
  pageInfo: PropTypes.object,
  result: PropTypes.object,
  handleChangePage: PropTypes.func,
  handleChangePageSize: PropTypes.func,
};
export default Orders;



// WEBPACK FOOTER //
// ./src/components/orders/index.js